import React from 'react';
import { Radio } from 'antd';
import { I18n } from '@aws-amplify/core';
import type { Rule } from 'antd/es/form';
import FormItem from '@/components/ui/FormItem';

interface LoadTransportInPairsFormItemProps {
	fieldName?: string | string[];
	required?: boolean;
}

export function LoadTransportInPairsFormItem({
	required = true,
	fieldName
}: Readonly<LoadTransportInPairsFormItemProps>): JSX.Element {
	const rule: Rule = {
		validator: (_, value) => {
			if (typeof value === 'boolean') {
				return Promise.resolve();
			}
			return Promise.reject(new Error(I18n.get('The field requires an answer')));
		}
	};

	const rules: Rule[] = required ? [rule] : [];

	return (
		<FormItem name={fieldName} label="Load transport in pairs?" required={required} rules={rules}>
			<Radio.Group style={{ marginTop: 8 }}>
				<Radio value={true}>{I18n.get('Yes')}</Radio>
				<Radio value={false} style={{ marginLeft: 24 }}>
					{I18n.get('No')}
				</Radio>
			</Radio.Group>
		</FormItem>
	);
}
